export default () => ({
  context: {
    groupSoftwareHash: '',
    site: {
      vehicleImageRatio: '',
      url: '',
      groupHash: '',
      franchiseHash: '',
      franchisePath: '',
      locationHash: '',
      country: 'GB',
      language: 'en',
      currency: {
        intlSymbol: 'GBP',
        symbol: '£',
      },
      unit: {
        isImperial: true,
      },
      googleMapKey: '',
      gforcesPaymentApiId: '',
      isOwnershipEnabled: false,
      ownershipUrl: '',
      privacyPageUrl: '',
      id: '',
      listingUrl: '/used-vehicles/',
      googleReviews: [],
    },
    trackingService: {
      module: 'snowplow',
    },
  },
});
